import IconApartment from "@/app/icons/apartment.svg";
import BigText from "@/app/_components/Shared/BigText";
import BadgeIcon from "@/app/icons/badge.svg";
import VisaIcon from "@/app/icons/visa.svg";

export const servicesData = [
    {
        "title": "Visa Management",
        "icon": VisaIcon,
    },
    {
        "title": "Trade Licenses",
        "icon": BadgeIcon,
    },
    {
        "title": "Government Liaison",
        "icon": IconApartment,
    },
    {
        "title": (<BigText >10+</BigText>),
    },
];

export const questions = [];